<template>
  <v-list-item :class="nav.styleClass ? nav.styleClass + ' left-nav-item' : 'left-nav-item'" :to="{ name: nav.name }">
    <v-list-item-avatar class="text-center">
    <v-icon color="secondary" class="ml-3 md-icon">{{ nav.icon }}</v-icon>
    </v-list-item-avatar>
    <v-list-item-content>
      <v-list-item-title class="secondary-color">{{ nav.title }}</v-list-item-title>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
export default {
  props: ['index', 'nav'],
}
</script>